import moment from 'moment';
import applicationStateApi from '../../api/ApplicationStateApi';
import customerState from '../../constants/customer-state';
import onboardingApi from '../../api/OnbordingApi';

const TOUR_EXPIRATION_IN_HOURS = 12;

const state = {
  notificationState: null,
  cashflowState: null,
  barState: null,
};

const getters = {
  notificationTypes: () => customerState.NOTIFICATION_STATE,
  cashflowTypes: () => customerState.CASHFLOW_STATE,
  barTypes: () => customerState.BAR_STATE,
  isActiveNotification: state => state.notificationState && state.notificationState !== customerState.NOTIFICATION_STATE.NONE,
};

const actions = {
  async initApplicationState({ commit, dispatch }) {
    const applicationState = await applicationStateApi.fetchApplicationState();
    commit('setCashflowState', applicationState.cashflowState);
    await dispatch('calcAndSetNotificationState', applicationState);
    dispatch('calcAndSetBarState');
  },
  async calcAndSetNotificationState({ commit, state, getters }, applicationState) {
    if (await shouldShowTour(applicationState)) {
      commit('setNotificationState', getters.notificationTypes.TOUR);
    } else {
      commit('setNotificationState', applicationState.notificationState);
    }
  },
  calcAndSetBarState({ commit, state, getters }) {
    if (state.cashflowState === getters.cashflowTypes.OUT_OF_DATE) {
      commit('setBarState', getters.barTypes.OUT_OF_DATE);
    }
    if (state.cashflowState === getters.cashflowTypes.BUG) {
      commit('setBarState', getters.barTypes.NOT_ACCURATE);
    }
    if (state.cashflowState === getters.cashflowTypes.BLOCKED) {
      commit('setBarState', getters.barTypes.NOT_AVAILABLE);
    }
  },
  async closeTour({ dispatch }) {
    localStorage.setItem('riseup.tourClosed', true);
    await dispatch('initApplicationState');
  },
};

async function shouldShowTour(applicationState) {
  const { onboardingState } = await onboardingApi.fetchOnboardingState();
  if (!onboardingState) {
    return false;
  }
  const activationDate = moment(applicationState.activationDate);
  if (moment().diff(activationDate, 'hours') > TOUR_EXPIRATION_IN_HOURS) {
    return false;
  }
  const tourClosed = localStorage.getItem('riseup.tourClosed');
  return !tourClosed;
}

// mutations
const mutations = {
  setNotificationState(state, notificationState) {
    state.notificationState = notificationState;
  },
  setCashflowState(state, cashflowState) {
    state.cashflowState = cashflowState;
  },
  setBarState(state, barState) {
    state.barState = barState;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
